import type { MapRegion } from "@/types"

export const samiRegion: MapRegion = {
    id: "sami",
    name: "map.region.sami",
    mapImage: require("@/assets/imgs/map/sami/map-sami.png"),
    decoImage: require("@/assets/imgs/map/sami/map-sami-deco.png"),
    startNodeId: "sm-start",
    endNodeId: "sm-end",
    startDirection: "left",
    unlocked: false,
    order: 1,
    iconConfig: {
        question: {
            highlightIcon: require("@/assets/imgs/map/sami/map-sami-question-mark.png"),
            width: 247,
            height: 285,
        },
    },
    nodes: [
        {
            id: "sm-start",
            type: "start",
            level: 0,
            position: { x: 1290, y: 700 },
            iconType: "question",
        },
        {
            id: "sm-evt1",
            type: "event",
            level: 1,
            position: { x: 1309, y: 292 },
            eventId: "evt-sm-01",
            iconType: "question",
        },
        {
            id: "sm-typhon",
            type: "event",
            level: 1,
            position: { x: 1037, y: 497 },
            eventId: "dlg-sm-typhon",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sami/map-sami-event-typhon.png"),
                width: 290,
                height: 316,
            },
        },
        {
            id: "sm-santalla",
            type: "event",
            level: 1,
            position: { x: 970, y: 282 },
            eventId: "dlg-sm-santalla",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sami/map-sami-event-santalla.png"),
                width: 271,
                height: 307,
            },
        },
        {
            id: "sm-evt4",
            type: "event",
            level: 2,
            position: { x: 720, y: 408 },
            eventId: "evt-sm-04",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sami/map-sami-event-4.png"),
                width: 468,
                height: 382,
            },
        },
        {
            id: "sm-evt3",
            type: "event",
            level: 2,
            position: { x: 596, y: 653 },
            eventId: "evt-sm-03",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sami/map-sami-event-3.png"),
                width: 449,
                height: 320,
            },
        },
        {
            id: "sm-evt5",
            type: "event",
            level: 2,
            position: { x: 575, y: 196 },
            eventId: "evt-sm-05",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sami/map-sami-event-5.png"),
                width: 392,
                height: 309,
            },
        },
        {
            id: "sm-evt2",
            type: "event",
            level: 3,
            position: { x: 208, y: 498 },
            eventId: "evt-sm-02",
            iconType: "question",
        },
        {
            id: "sm-end",
            type: "end",
            level: 4,
            position: { x: 210, y: 199 },
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sami/map-sami-target.png"),
                width: 244,
                height: 274,
            },
        },
    ],
    edges: [
        { from: "sm-start", to: "sm-evt1", waypoints: [] },
        { from: "sm-start", to: "sm-typhon", waypoints: [] },
        { from: "sm-evt1", to: "sm-santalla", waypoints: [] },
        { from: "sm-evt1", to: "sm-typhon", waypoints: [] },
        { from: "sm-santalla", to: "sm-evt5", waypoints: [] },
        { from: "sm-typhon", to: "sm-evt3", waypoints: [] },
        { from: "sm-typhon", to: "sm-evt4", waypoints: [] },
        { from: "sm-evt3", to: "sm-evt2", waypoints: [] },
        { from: "sm-evt4", to: "sm-evt5", waypoints: [] },
        { from: "sm-evt4", to: "sm-end", waypoints: [] },
        { from: "sm-evt2", to: "sm-end", waypoints: [] },
        { from: "sm-evt5", to: "sm-end", waypoints: [] },
    ],
}
